import { createAction, handleActions } from 'redux-actions';

const setFilters = createAction("SCREENS/ORDERS/SET_FILTERS");

const defaultState = {
  client_id: [],
  extra_works: 'all',
  date_between: undefined,
  po_loaded: 'all',
  sent_to_subcontractor: 'all',
  procurement_only: 'all',
};

const reducer = handleActions(
  {
    [setFilters]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setFilters, reducer };
